import { getAccessToken } from "src/authentication-and-logging/authAndLogger";

const ApplicationTypeJson = "application/json";

export async function getHeaders() {
	const token = await getAccessToken();
	return {
		"Authorization": `Bearer ${token}`,
		"Content-Type": ApplicationTypeJson,
	};
}
